import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Activity, Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Admin");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full border border-white/15 bg-slate-950 px-4 py-3 text-white outline-none transition-colors duration-200 placeholder:text-slate-500 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500";

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-slate-900 p-6">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[400px] w-[500px] -translate-x-1/2 rounded-full bg-emerald-500/10 blur-[120px]" />
      <div className="relative w-full max-w-md border border-white/10 bg-slate-950 p-10">
        <div className="mb-8">
          <img src="/logo.png" alt="Ticker Templates" className="h-11 w-auto" />
        </div>
        <h1 className="font-display text-3xl font-black uppercase tracking-tight text-white">Secure sign in</h1>
        <p className="mt-2 text-sm text-slate-400">Only authenticated operators can run the pricing & autopilot engine.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="mb-1.5 block font-mono text-[10px] uppercase tracking-wider text-slate-500">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@tickertemplates.com" className={input} />
          </div>
          <div>
            <label className="mb-1.5 block font-mono text-[10px] uppercase tracking-wider text-slate-500">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={input} />
          </div>
          <button data-testid="login-submit" disabled={loading} className="flex w-full items-center justify-center gap-2 bg-emerald-500 px-6 py-3.5 font-semibold text-slate-900 transition-[background-color] duration-200 hover:bg-emerald-400 disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            {loading ? "Signing in..." : "Sign in"}
          </button>
          <Link to="/forgot-password" data-testid="forgot-password-link" className="block pt-1 text-center font-mono text-xs text-slate-500 transition-colors duration-200 hover:text-emerald-400">
            Forgot your password?
          </Link>
        </form>
      </div>
    </div>
  );
}
